import Request from "./index";

class api {
  // 获取学校平台点播流量是否还有空闲
  static getVideoFree(data) {
    return Request.get(`/operate/school_manage/is_video_flux_free`, {
      params: data
    });
  }

  // 获取学校平台直播流量是否还有空闲
  static getLiveFree(data) {
    return Request.get(`/operate/school_manage/is_live_flux_free`, {
      params: data
    });
  }
}
export default api;
